var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-module",class:_vm.componentName},[_c(_vm.componentName,{tag:"component",attrs:{"attributes":_vm.module}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }